import React from "react";
import { BadgeCheck, Star, ShieldCheck, Clock } from "lucide-react";
import { EXCELLENCE } from "../mock";
import Reveal from "./Reveal";

const ICONS = {
  check: BadgeCheck,
  star: Star,
  shield: ShieldCheck,
  clock: Clock,
};

const Excellence = () => {
  return (
    <section id="excellence" className="bg-[#F5F2ED] border-y border-[#E9E5DE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <Reveal>
          <p className="font-body text-sm text-[#2B4BFF] font-semibold mb-3">{EXCELLENCE.kicker}</p>
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533] max-w-3xl leading-[1.05]">
            {EXCELLENCE.title}
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {EXCELLENCE.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={i * 90} className="flex flex-col gap-3">
                {Icon && <Icon size={26} className="text-[#2B4BFF]" />}
                <h3 className="font-heading font-semibold text-lg tracking-tight text-[#0B1533]">
                  {item.title}
                </h3>
                <p className="font-body text-sm text-[#5A607A]">{item.desc}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Excellence;
